export const getParams = (paramsKey: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(paramsKey)
}

export const objectToQueryParams = (
  object: Record<string, unknown> | string | null | undefined,
): string => (object ? `?${new URLSearchParams(object as Record<string, string>).toString()}` : '')

export default getParams
